import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { OwnersListResponse } from '@modules/groups-of-admins/submodules/create/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { GROUPS_OF_ADMINS_PERMISSIONS } from '@modules/groups-of-admins/constants';
import {
  GROUPS_OF_ADMINS_CREATE_API_URL,
  GROUPS_OF_ADMINS_CREATE_QUERY_KEY,
} from '@modules/groups-of-admins/submodules/create/constants';

export default function useGroupOwnersListQuery(): IContextQueryResult<OwnersListResponse[], Error> {
  const { fetchGet } = useRestClient();

  return useContextQuery<OwnersListResponse[], Error>({
    queryKey: [GROUPS_OF_ADMINS_CREATE_QUERY_KEY],
    queryFn: ({ signal }) => fetchGet<OwnersListResponse[]>(GROUPS_OF_ADMINS_CREATE_API_URL, {
      signal,
      permission: GROUPS_OF_ADMINS_PERMISSIONS.EDIT,
    }),
  });
}
